/** The token the stock order confirmation renders the legacy Customer Email Text through. */
export const CUSTOMER_EMAIL_TEXT_TOKEN = '{{{customer_email_text}}}';

/**
 * What the Order Email Template editor should show when the storefront has no template of its own.
 *
 * Plain default when there is nothing to carry over. When the deprecated Customer Email Text still
 * holds a value, that value is substituted into the default at the position the stock template
 * already renders it — so the merchant opens the editor on the email they are actually sending,
 * their own words included, rather than on a token that hides them.
 *
 * Substituted RAW, exactly as the server does: the send path tokenizes this template without
 * escaping, so the text is already going into the HTML unescaped today. Escaping it here would
 * change what a storefront sends the moment someone saved, which is the one thing this migration
 * must not do.
 *
 * This only ever seeds the EDITOR. Nothing is written until an edit is made, so a merchant who never
 * opens the field keeps the setting empty and keeps getting the default from the API — and their
 * Customer Email Text keeps rendering through the token as it does now. Saving is what completes the
 * move: the text becomes part of the template, and the deprecated field stops mattering.
 */
export function buildOrderTemplatePrefill(defaultBody?: string, customerEmailText?: string): string | undefined {
    if (!defaultBody) return defaultBody;
    const legacy = customerEmailText?.trim();
    if (!legacy) return defaultBody;
    return defaultBody.split(CUSTOMER_EMAIL_TEXT_TOKEN).join(customerEmailText ?? '');
}
